// import logo from './logo.svg';
import "./App.css";
import Alerts from "./components/Alerts";
import Navbar from "./components/Navbar";
import About from "./components/About";
import TextForm from "./components/TextForm";
import React, { useState } from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  const [mode, setMode] = useState("light"); // Whether dark mode is enabled or not

  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 1500);
  };

  const toggleMode = () => {
    if (mode === 'light') {
      setMode('dark');
      document.body.style.backgroundColor = '#042743';
      showAlert("Dark mode has been enabled", "success");
      // document.title = 'TextUtils - Dark Mode';
      // setInterval(() => {
      //   document.title = 'TextUtils is Amazing Mode';
      // }, 2000);
      // setInterval(() => {
      //   document.title = 'Install TextUtils Now';
      // }, 1500);
    } else {
      setMode('light');
      document.body.style.backgroundColor = 'white';
      showAlert("Light mode has been enabled", "success");
      // document.title = 'TextUtils - Light Mode';
    }
  };
  // const[redMode, setRedMode] = useState('light'); // Whether red mode is enabled or not

  // const toggleRedMode = () => {
  //   if (redMode === 'light') {
  //     setRedMode('red');
  //     document.body.style.backgroundColor = '#DC143C';
  //     showAlert("Red mode has been enabled", "success");
  //     document.title = 'TextUtils - Red Mode';
  //   } else {
  //     setRedMode('light');
  //     document.body.style.backgroundColor = 'white';
  //     showAlert("Light mode has been enabled", "success");
  //     document.title = 'TextUtils - Light Mode';
  //   }
  // };
  // const changeMode = (color) => {
  //   if (color === "light") {
  //     setMode("light");

  //     document.body.style.backgroundColor = "white";
  //     document.body.style.color = "black";
  //   } else if (color === "dark") {
  //     setMode("dark");

  //     document.body.style.backgroundColor = "#042743";
  //     document.body.style.color = "white";
  //   } else if (color === "red") {
  //     document.body.style.backgroundColor = "#DC143C";
  //     document.body.style.color = "white";
  //   }
  // };
  return (
    <>
      <Router>
        <Navbar
          title="TextUtils"
          mode={mode}
          toggleMode={toggleMode}
          aboutText="About Us"
        />

        <Alerts alert={alert} />
        <div className="container my-3">
          <Routes>
            <Route
              path="/"
              element={
                <TextForm
                  mode={mode}
                  showAlert={showAlert}
                  heading="Try TextUtils - Word counter, Character Counter, Remove extra spaces, Knows the Pronunciation :"
                />
              }
            />
            <Route path="/about" element={<About mode={mode} />} />
          </Routes>
        </div>
      </Router>
    </>
  );
}

export default App;
